import React from 'react'
import './styles.scss'

const charts = {
  Basel: require('../chart/img/basel.svg'),
  Bellinzona: require('../chart/img/bellinzona.svg'),
  Bern: require('../chart/img/bern.svg'),
  Brusio: require('../chart/img/brusio.svg'),
  'Locarno-Monti': require('../chart/img/locarno-monti.svg'),
  Lugano: require('../chart/img/lugano.svg'),
  Neuenburg: require('../chart/img/neuenburg.svg'),
  Sion: require('../chart/img/sion.svg'),
  Visp: require('../chart/img/visp.svg'),
  Zürich: require('../chart/img/zuerich.svg'),

  Klosters: require('../chart/img/klosters.svg'),
  Lauterbrunnen: require('../chart/img/lauterbrunnen.svg'),
  Einsiedeln: require('../chart/img/einsiedeln.svg'),
  'La Chaux de Fonds': require('../chart/img/la-chaux-de-fonds.svg'),
  Engelberg: require('../chart/img/engelberg.svg'),
  Küblis: require('../chart/img/kueblis.svg'),
  Airolo: require('../chart/img/airolo.svg'),
  Poschiavo: require('../chart/img/poschiavo.svg'),
  Scuol: require('../chart/img/scuol.svg'),
  'Campo Blenio': require('../chart/img/campo-blenio.svg'),

  Ritom: require('../chart/img/ritom.svg'),
  Zuoz: require('../chart/img/zuoz.svg'),
  Samedan: require('../chart/img/samedan.svg'),
  Cavaglia: require('../chart/img/cavaglia.svg'),
  'Bosco Gurin': require('../chart/img/bosco_gurin.svg'),
  Mürren: require('../chart/img/muerren.svg'),
  Grindelwald: require('../chart/img/grindelwald.svg'),
  Davos: require('../chart/img/davos.svg'),
  'St. Antönien': require('../chart/img/st-antoenien.svg'),
  Zermatt: require('../chart/img/zermatt.svg'),
  Andermatt: require('../chart/img/andermatt.svg'),
  Ulrichen: require('../chart/img/ulrichen.svg'),
  Trübsee: require('../chart/img/truebsee.svg')
}

// const icons = {
//   North: require('../chart/img/nord.svg'),
//   South: require('../chart/img/sued.svg')
// }

// const icons = {
//   'Krankheit (2500)': require('../chart/img/krankheit.svg')
// }

export default class chart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: false
    }
    this.toggleMore = this.toggleMore.bind(this)
  }

  toggleMore(e) {
    e.preventDefault()
    if (this.state.isExpanded) {
      this.setState(
        {
          isExpanded: false
        },
        () => console.log('collapse!')
      )
    } else {
      this.setState(
        {
          isExpanded: true
        },
        () => console.log('expand...')
      )
    }
  }

  render() {
    return (
      <div className='snowdays-wrapper'>
        <div className='title-wrapper'>
          <div className='location'>
            <p>
              {this.props.location}{' '}
              {/* <span className='percentage highlight'>{this.props.percentage}%</span>
              <span className='percentageText'> {this.props.percentageText}</span> */}
            </p>
          </div>
          <div className='right'>
            <p>
              <span className='hoehe'> {this.props.meter} </span>
            </p>
          </div>
          {/* <div className='icon-wrapper'>
            <img
              src={icons[this.props.direction]}
              alt=''
              className='icons ui fluid image'
            />
          </div> */}
        </div>
        <div className='snowdays-percentage'>
          <span className='percentage highlight'>{this.props.percentage}%</span>
          <span className='percentageText'> {this.props.percentageText}</span>
        </div>
        <div className='snowdays-shape'>
          <img
            src={charts[this.props.title]}
            alt=''
            className='ui fluid image'
          />
        </div>
      </div>
    )
  }
}
